export const isUndefined = (value) => typeof value === "undefined" || value === undefined
export const isNull = (value) => value === null
export const isNil = (value) => isNull(value) || isUndefined(value)

export default function isset(value) {
  return !isNil(value)
}
